import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildFiveSegmentsBrandsData,
  type FiveSegmentsBrandData,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { useSampleSize } from '~/hooks/useSampleSize'

import { fiveSegmentSortValueAtom } from '../atoms'

import { useNineSegmentsBrandsData } from './useNineSegmentsBrandsData'

export const useFiveSegmentsBrandsData = (): FiveSegmentsBrandData[] => {
  const nineSegmentsBrandsData = useNineSegmentsBrandsData()
  const sampleSize = useSampleSize()
  const sortValue = useAtomValue(fiveSegmentSortValueAtom)

  return React.useMemo(
    () =>
      buildFiveSegmentsBrandsData({
        nineSegmentsBrandsData,
        sampleSize,
        sortValue,
      }),
    [nineSegmentsBrandsData, sampleSize, sortValue],
  )
}
